
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyRentalHistoryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MyRentalHistory"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyRentalItemFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCurrentRentals"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":159}};
    doc.loc.source = {"body":"#import \"../fragments/my-rental-item.gql\"\n\nfragment MyRentalHistoryFields on MyRentalHistory {\n  items {\n    ...MyRentalItemFields\n  }\n  totalCurrentRentals\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragments/my-rental-item.gql").definitions));


      module.exports = doc;
    
